import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import { IconPlayerPauseFilled, IconPlayerPlayFilled } from "@tabler/icons-react";
import { cn } from "@/shared/lib/utils";
// Реальные треки-примеры (S3, REACT_APP_LANDING_ASSETS_BASE) — те же, что на
// WelcomePage: один источник, чтобы примеры не разъезжались между лендингами.
import { asset, TRACKS } from "@/pages/web/WelcomePage/content";
import { trackKey } from "./trackKey";
import styles from "./Sections.module.scss";
/** mm:ss из секунд. */
const fmt = (sec) => {
    if (!Number.isFinite(sec) || sec < 0)
        return "0:00";
    return `${Math.floor(sec / 60)}:${String(Math.floor(sec % 60)).padStart(2, "0")}`;
};
/**
 * Сетка примеров с одним общим аудио-элементом. Аудио ленивое: `preload="none"`
 * и `src` ставится только по клику — страница не качает ни байта mp3, пока
 * человек сам не нажмёт «слушать» (и пререндер тоже).
 */
export const Examples = ({ tracks }) => {
    const list = tracks
        ? tracks
            .map((k) => TRACKS.find((t) => trackKey(t) === k))
            .filter((t) => Boolean(t))
        : TRACKS;
    const audioRef = React.useRef(null);
    const [current, setCurrent] = React.useState(null);
    const [playing, setPlaying] = React.useState(false);
    const [progress, setProgress] = React.useState(0);
    const [time, setTime] = React.useState(0);
    const pick = (i) => {
        const a = audioRef.current;
        if (!a)
            return;
        if (current === i) {
            if (a.paused)
                void a.play().catch(() => setPlaying(false));
            else
                a.pause();
            return;
        }
        a.src = asset(list[i].song);
        setCurrent(i);
        setProgress(0);
        setTime(0);
        void a.play().catch(() => setPlaying(false));
    };
    return (_jsxs(_Fragment, { children: [_jsx("audio", { ref: audioRef, preload: "none", onPlay: () => setPlaying(true), onPause: () => setPlaying(false), onEnded: () => {
                    setPlaying(false);
                    setProgress(0);
                }, onTimeUpdate: (e) => {
                    const el = e.currentTarget;
                    setTime(el.currentTime);
                    if (el.duration)
                        setProgress(el.currentTime / el.duration);
                } }), _jsx("ul", { className: styles.tracks, children: list.map((t, i) => {
                    const active = current === i;
                    const isPlaying = active && playing;
                    return (_jsx("li", { children: _jsxs("button", { type: "button", className: cn(styles.track, active && styles.trackActive), onClick: () => pick(i), "aria-label": `Слушать: ${t.title}`, "aria-pressed": isPlaying, children: [_jsxs("span", { className: styles.trackCover, children: [_jsx("img", { src: asset(t.cover), alt: `Обложка трека «${t.title}»`, loading: "lazy", decoding: "async", width: 72, height: 72 }), _jsx("span", { className: styles.trackPlay, "aria-hidden": "true", children: isPlaying ? _jsx(IconPlayerPauseFilled, { size: 18 }) : _jsx(IconPlayerPlayFilled, { size: 18 }) })] }), _jsxs("span", { className: styles.trackBody, children: [_jsx("span", { className: styles.trackTitle, children: t.title }), _jsxs("span", { className: styles.trackMeta, children: [_jsx("span", { children: t.genre }), _jsx("span", { className: styles.trackDur, children: active ? `${fmt(time)} / ${t.dur}` : t.dur })] }), _jsx("span", { className: styles.trackProgress, "aria-hidden": "true", children: _jsx("span", { style: { transform: `scaleX(${active ? progress : 0})` } }) })] })] }) }, t.song));
                }) })] }));
};
